(function () {
  'use strict';

  var RELOAD_ONCE_KEY = 'pd_mfb_market_reload_once';

  function getMarket() {
    return window.__heritageMarket || null;
  }

  function isBoostPage() {
    var path = window.location.pathname || '';
    return path.indexOf('/collections/') === 0 || path.indexOf('/search') === 0;
  }

  function syncBoostParams(market) {
    if (!market) return;
    window.boostSdCustomParams = Object.assign({}, window.boostSdCustomParams || {}, {
      country: market.country,
      currency: market.currency,
    });
  }

  var reinitTimer = null;
  var lastReinitAt = 0;
  var REINIT_DEBOUNCE_MS = 1000;

  function reinitBoostFilter() {
    if (!isBoostPage()) return false;
    if (window.boostSDTaeUtils && typeof window.boostSDTaeUtils.initCollectionFilter === 'function') {
      var now = Date.now();
      if (now - lastReinitAt < REINIT_DEBOUNCE_MS) {
        return false;
      }
      lastReinitAt = now;
      window.boostSDTaeUtils.initCollectionFilter();
      return true;
    }
    return false;
  }

  function scheduleReinitBoostFilter() {
    if (reinitTimer !== null) {
      window.clearTimeout(reinitTimer);
    }
    reinitTimer = window.setTimeout(function () {
      reinitTimer = null;
      reinitBoostFilter();
    }, 150);
  }

  function getDisplayedCurrency() {
    var text = document.querySelector('.heritage-localization-form .localization-form__select-text');
    if (!text) return '';
    var match = text.textContent.match(/·\s*([A-Z]{3})\b/);
    return match ? match[1] : '';
  }

  function marketMismatch() {
    var market = getMarket();
    if (!market || !market.currency) return false;

    var displayed = getDisplayedCurrency();
    if (displayed && displayed !== market.currency) return true;

    var hiddenInput = document.querySelector('.heritage-localization-form input[name="country_code"]');
    if (hiddenInput && market.country && hiddenInput.value !== market.country) return true;

    return false;
  }

  function reloadOnceIfNeeded() {
    var url = window.location.href;
    if (sessionStorage.getItem(RELOAD_ONCE_KEY) === url) return false;
    sessionStorage.setItem(RELOAD_ONCE_KEY, url);
    window.location.reload();
    return true;
  }

  function recoverMarketState(trigger) {
    var market = getMarket();
    if (!market) return;

    syncBoostParams(market);

    if (trigger === 'pageshow' && marketMismatch()) {
      if (reloadOnceIfNeeded()) return;
    }

    if (trigger !== 'ready') {
      scheduleReinitBoostFilter();
    }

    if (marketMismatch()) {
      window.setTimeout(function () {
        if (!marketMismatch()) return;
        reloadOnceIfNeeded();
      }, 500);
    }
  }

  function onPageShow(event) {
    if (event.persisted || marketMismatch()) {
      window.setTimeout(function () {
        recoverMarketState('pageshow');
      }, 0);
    }
  }

  document.addEventListener('heritage:market:recover', function () {
    recoverMarketState('manual');
  });

  document.addEventListener('heritage:market:changed', function () {
    recoverMarketState('market-changed');
  });

  window.addEventListener('pageshow', onPageShow);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      recoverMarketState('ready');
    });
  } else {
    recoverMarketState('ready');
  }
})();
